/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Filter_CategoryInputs */

const vi_shop_group_filter_category = /** @type {(inputs: Shop_Group_Filter_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục`)
};

/**

* @param {Shop_Group_Filter_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_filter_category = /** @type {((inputs?: Shop_Group_Filter_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Filter_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_filter_category(inputs)
});